import { InvoiceResult } from "../entity/History";
import HistoryRepository from "../repository/HistoryRepository";

export default class HistoryUseCase implements HistoryRepository {
  constructor(private repository: HistoryRepository) {
    this.repository = repository;
  }

  getTransaction(
    filterStatus: string,
    filterProduct: string,
    startDate: string,
    endDate: string,
    search: string,
    pageNumber: string,
    size: string,
  ): Promise<any> {
    return this.repository.getTransaction(
      filterStatus,
      filterProduct,
      startDate,
      endDate,
      search,
      pageNumber,
      size
    );
  }
  getInvoice(
    billerid: string,
    bookid: string,
    productid: string
  ): Promise<InvoiceResult> {
    return this.repository.getInvoice(billerid, bookid, productid);
  }
  getGenerateLink(bookId: string): Promise<any> {
    return this.repository.getGenerateLink(bookId);
  }
  getDetailInvoice(bookId: string): Promise<any> {
    return this.repository.getDetailInvoice(bookId);
  }
}
